export default __webpack_public_path__ + "static/media/Whisperer of Evil Luck.469674a6.jpg";